module.exports = __webpack_public_path__ + "static/media/A-empty-open.4d846340.svg";